import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { ModalLayout, ForwardRefHandlers } from '../ModalLayout';
import SoundSettings from '@/components/Setting/Sound';
import WindowSettings from '@/components/Setting/Window';
import UserSettings from '@/components/Setting/User';
import { SteamUser } from '@/types/user';
import { useAudio } from '@/context/AudioContext';
import ServerSettings from '@/components/Setting/Server';
import { useRouter } from 'next/router';

type TabType = 'display' | 'sound' | 'game' | 'server';

interface Props {
  onClose: () => void;
  onChangeName?: (userId: string, name: string) => void;
  onChangeAvatar?: (user: SteamUser) => void;
}

const tabs: { label: string; value: TabType }[] = [
  { label: 'displaySetting', value: 'display' },
  { label: 'soundSetting', value: 'sound' },
  { label: 'gameSetting', value: 'game' },
];

export default function SettingModal({
  onClose,
  onChangeName,
  onChangeAvatar,
}: Props) {
  const { playSoundEffect } = useAudio();

  const { t, i18n } = useTranslation();
  const ref = React.useRef<ForwardRefHandlers>(null);
  const [tabType, setTabType] = React.useState<TabType>('display');

  const handleChangeTab = (tabType: TabType) => () => {
    playSoundEffect('click_button');
    setTabType(tabType);
  };

  return (
    <ModalLayout
      className="!h-[560px] !bg-contain !p-2 !px-6"
      width={760}
      ref={ref}
      onClose={onClose}
    >
      <div className="p-6 h-full  ">
        <div className="grid grid-cols-3 gap-8 mb-8">
          {tabs.map((tab) => (
            <div
              key={tab.value}
              className={`text-2xl font-bold cursor-pointer relative text-center ${
                tabType === tab.value ? 'text-brown-primary' : 'text-gray-400'
              } hover:text-brown-primary hover:opacity-90`}
              style={{ backgroundSize: '100% 180%' }}
              onClick={handleChangeTab(tab.value)}
            >
              <span>{t(tab.label)}</span>
            </div>
          ))}
        </div>
        <div className=" text-brown-primary">
          {tabType === 'display' && <WindowSettings />}
          {tabType === 'sound' && <SoundSettings />}
          {tabType === 'game' && (
            <UserSettings
              onChangeName={onChangeName}
              onChangeAvatar={onChangeAvatar}
            />
          )}
          {tabType === 'server' && <ServerSettings />}
        </div>
      </div>
    </ModalLayout>
  );
}
